(function () {
  'use strict';

  angular
      .module('eltazkara.footer', [])

})();
